import { render, staticRenderFns } from "./SettingsCompanySettings.vue?vue&type=template&id=772f6b5b"
import script from "./SettingsCompanySettings.vue?vue&type=script&lang=js"
export * from "./SettingsCompanySettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports